export default __webpack_public_path__ + "static/media/recipe.75141e76.svg";